import log from './logger';

const STATUS_FALLBACKS = {
  400: 'errorBadRequest',
  401: 'errorUnauthorized',
  403: 'errorForbidden',
  404: 'errorNotFound',
  409: 'errorConflict',
  422: 'errorUnprocessable',
  429: 'errorTooManyRequests',
  500: 'errorServer',
  502: 'errorBadGateway',
  503: 'errorServiceUnavailable',
};

export const getApiErrorMessage = (err, t, fallbackKey = 'unexpectedError') => {
  const data = err?.response?.data;
  const serverMessage = typeof data?.publicMessage === 'string' && data.publicMessage.trim().length > 0
    ? data.publicMessage.trim()
    : null;
  const serverCode = typeof data?.errorCode === 'string' ? data.errorCode : null;

  const rawServerMessage = [data?.error, data?.message, data?.msg].find(
    (value) => typeof value === 'string' && value.trim().length > 0,
  );

  log.error('API error:', {
    status: err?.response?.status,
    url: err?.config?.url,
    message: err?.message,
    serverMessage: rawServerMessage,
    errorCode: serverCode,
  });

  if (serverMessage) {
    return serverMessage;
  }

  if (serverCode) {
    const translated = t(serverCode);
    if (translated && translated !== serverCode) {
      return translated;
    }
  }

  const statusKey = STATUS_FALLBACKS[err?.response?.status];
  if (statusKey) {
    const translated = t(statusKey);
    if (translated && translated !== statusKey) {
      return translated;
    }
  }

  return t(fallbackKey);
};
